import { Alert, Badge } from "@/shared/components/MDX/MDXComponents";

# 📦 راهنمای لیست خانواده محصولات (BOM)

پلتفرم کارخانه‌سازی میمزاد (Mimzad Manufacturing Platform) — سند راهنمای کاربری خانواده محصولات (BOM)

<Badge type="gold">سند استاندارد کاربری</Badge> <Badge>راهنمای جامع</Badge>

## 📋 معرفی لیست خانواده محصولات

این صفحه نمایش‌دهنده تمام خانواده‌های ساختاری محصولات (BOM Families) در کارخانه شما است. در سیستم میمزاد، BOM یا لیست مواد (Bill of Materials)، پایه و اساس تولید است که به صورت خانواده و نسخه‌های مختلف (Revisions) مدیریت می‌شود.

### امکانات این صفحه:

- **جستجو:** می‌توانید خانواده‌های محصول را بر اساس کد یا نام جستجو کنید.
- **ایجاد خانواده جدید:** با کلیک بر روی دکمه **«➕ خانواده جدید»**، می‌توانید یک محصول پایه جدید را در سیستم تعریف کنید.
- **مشاهده جزئیات:** با کلیک بر روی هر کارت خانواده محصول، وارد صفحه جزئیات آن شده و می‌توانید نسخه‌های مختلف ساختار آن محصول را مدیریت کنید.

<Alert type="info">
  ساختار BOM در سیستم میمزاد به صورت **چندسلسله‌مراتبی (Multi-Level)** و بر پایه **خانواده (Family)** و **نسخه (Revision)** طراحی شده است. هر خانواده نشان‌دهنده یک محصول و هر نسخه نشان‌دهنده یک دستور ساخت خاص برای آن محصول است.
</Alert>
